<div class="add-customer-container" style="min-width: 380px; margin-right: auto; box-shadow: none; border-radius: 0; background: none;">
  <div class="card shadow-sm rounded-4 border-0">
    <div class="card-body p-4">
      <div *ngIf="saveSuccess" class="alert alert-success col-md-7" role="alert" data-testid="success-alert">
        Organization added successfully.
      </div>
      <div *ngIf="serverError" class="alert alert-danger col-md-7" role="alert" data-testid="error-alert">
        A server error occured. Please try again later.
      </div>
      <form [formGroup]="stepForm" (ngSubmit)="save()" style="max-width: 940px;" class="customer-form" data-testid="add-customer-form">
        <div class="mb-3 mt-3">
          <label for="companyType" class="form-label">Company Type <span class="text-danger">*</span></label>
          <select id="companyType" class="form-select fancy-select" formControlName="companyType" required data-testid="company-type-dropdown">
            <option value="">Select company type</option>
            <option *ngFor="let type of types" [value]="type.orgTypeId">{{ type.orgTypeName }}</option>
          </select>
          <div class="text-danger mt-1" *ngIf="stepForm.get('companyType')?.invalid && stepForm.get('companyType')?.touched">
            Please select a company type.
          </div>
        </div>
        <div class="mb-3">
          <label for="name" class="form-label">Organization Name<span class="text-danger">*</span></label>
          <input
            id="name"
            class="form-control"
            [ngClass]="{'is-invalid': stepForm.get('name')?.invalid && stepForm.get('name')?.touched}"
            formControlName="name"
            placeholder="Organization Name"
            required
            data-testid="organization-name-field"
          />
          <div class="invalid-feedback d-block" *ngIf="stepForm.get('name')?.invalid && stepForm.get('name')?.touched">
            Organization name is a mandatory field.
          </div>
        </div>
        <div class="mb-3">
          <label for="alias" class="form-label">Display name</label>
          <input id="alias" class="form-control" formControlName="alias" placeholder="Display name or alias" data-testid="organization-alias-field" />
        </div>
        <div class="row g-2 mb-2">
          <div class="col">
            <label for="soldTo" class="form-label">Sold To</label>
            <input id="soldTo" class="form-control" formControlName="soldTo" placeholder="Sold To" data-testid="sold-to-field" />
          </div>
          <div class="col-md-6">
            <label for="shipTo" class="form-label">Ship To</label>
            <input id="shipTo" class="form-control" formControlName="shipTo" placeholder="Ship To" data-testid="ship-to-field" />
          </div>
        </div>
        <div class="form-check mb-2">
          <input type="checkbox" class="form-check-input" id="excludeReferrals" formControlName="excludeReferrals" style="transform: scale(1.1); margin-right: 6px;" />
          <label class="form-check-label fs-6" for="excludeReferrals">Exclude Referrals</label>
        </div>
        <div class="form-check mb-2">
          <input type="checkbox" class="form-check-input" id="active" formControlName="active" style="transform: scale(1.1); margin-right: 6px;" />
          <label class="form-check-label fs-6" for="active">Active</label>
        </div>
        <button type="submit" class="btn btn-gradient w-100 py-3 mt-3" [disabled]="isLoading || stepForm.invalid" data-testid="save-organization-btn">
          <span *ngIf="isLoading">Saving...</span>
          <span *ngIf="!isLoading">Save Organization</span>
        </button>
      </form>
    </div>
  </div>
</div>
